import { useToast } from '@/hooks/use-toast';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';
// import React = require("react");

export function Toaster() {
  const { toasts } = useToast();
  const defaultSuccessMessage = 'Endringer lagret.';
  const defaultErrorMessage = 'Beklager, men noe gikk galt.';

  const setToastDefaultTitle = (type) =>
    type && type === 'Error' ? defaultErrorMessage : defaultSuccessMessage;

  return (
    <ToastProvider>
      {toasts.map(function ({
        id,
        title,
        description,
        action,
        type,
        defaultTitle = true,
        ...props
      }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title ||
                (defaultTitle && (
                  <ToastTitle>
                    {title ? title : setToastDefaultTitle(type)}
                  </ToastTitle>
                ))}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
